'use strict';
import React from 'react';
import flux from 'utils/flux';

var ThumbnailViewer = React.createClass({
    displayName: 'ThumbnailViewer',
    render() {
        let deviation = 4
        let isAtStart = this.props.currentIndex <= 3;

        let leftButtonsVisibilityValue = this.props.currentIndex === 0 ? 'hidden' : 'visible';
        let leftButtonsVisibility = { visibility: leftButtonsVisibilityValue };

        let rightButtonsVisibilityValue = this.props.currentIndex === this.props.thumbnails.length - 1 ? 'hidden' : 'visible';
        let rightButtonsVisibility = { visibility: rightButtonsVisibilityValue };

        return (
            <div className="modal__thumbnail__viewer">
                <div className="modal__thumbnail__viewer_buttons_left" style={leftButtonsVisibility}>
                    <button onClick={this.props.goToFirstImage}
                        className="actions__switch-previous actions__switch" title={flux.t('first-page')}>
                        <div className="switch__button">
                            <i className="double-arrow-left" />
                        </div>
                    </button>
                    <button onClick={this.props.goToPreviousImage}
                        className="actions__switch-previous actions__switch" title={flux.t('pagination_back')}>
                        <div className="switch__button">
                            <i className="media-arrow-left" />
                        </div>
                    </button>
                </div>
                <div className="modal__thumbnail__viewer_thumbnails">
                    {this.props.thumbnails.map((item, index) => {
                        return (
                            (isAtStart || (!isAtStart && index > this.props.currentIndex - deviation)) &&
                            <figure className={index === this.props.currentIndex ? "thumbnail__current" : "thumbnail__regular"} onClick={this.props.goToIndex.bind(null, index)}>
                                <img className="thumbnail__image"
                                    src={item.thumbnail.src} />
                                <figcaption>{index + 1}</figcaption>
                            </figure>
                        );
                    })}
                </div>

                <div className="modal__thumbnail__viewer_buttons_right" style={rightButtonsVisibility}>
                    <button onClick={this.props.goToNextImage}
                        className="actions__switch-previous actions__switch" title={flux.t('pagination_next')}>
                        <div className="switch__button">
                            <i className="media-arrow-right" />
                        </div>
                    </button>
                    <button onClick={this.props.goToLastImage}
                        className="actions__switch-previous actions__switch" title={flux.t('last-page')}>
                        <div className="switch__button">
                            <i className="double-arrow-right" />
                        </div>
                    </button>
                </div>
            </div>
        )
    }
});

module.exports = ThumbnailViewer;


// WEBPACK FOOTER //
// ./app/components/thumbnailViewer/thumbnailViewer.jsx